import { create } from 'zustand';

export interface Message {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
  suggestions?: Array<{
    text: string;
    type: 'message' | 'navigate' | 'show_contacts';
    path?: string;
  }>;
}

interface ChatState {
  messages: Message[];
  isTyping: boolean;
  error: string | null;

  // Actions
  addMessage: (message: Omit<Message, 'id' | 'timestamp'>) => void;
  setTyping: (isTyping: boolean) => void;
  setError: (error: string | null) => void;
  clearMessages: () => void;
  loadMessagesFromStorage: () => void;
  saveMessagesToStorage: () => void;
}

const STORAGE_KEY = 'ai_chat_history';

export const useChatStore = create<ChatState>((set, get) => ({
  messages: [],
  isTyping: false,
  error: null,

  addMessage: (message) => {
    const newMessage: Message = {
      ...message,
      id: crypto.randomUUID(),
      timestamp: new Date()
    };

    set((state) => ({
      messages: [...state.messages, newMessage]
    }));

    // Сохраняем в localStorage
    get().saveMessagesToStorage();
  },

  setTyping: (isTyping) => set({ isTyping }),

  setError: (error) => set({ error }),

  clearMessages: () => {
    set({ messages: [] });
    localStorage.removeItem(STORAGE_KEY);
  },

  loadMessagesFromStorage: () => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const messages = JSON.parse(stored);
        // Преобразуем timestamp обратно в Date
        const messagesWithDates = messages
          .filter((m: any) => m.content && m.content.trim())
          .map((m: any) => ({
            ...m,
            timestamp: new Date(m.timestamp)
          }));
        set({ messages: messagesWithDates });
      }
    } catch (error) {
      console.error('Error loading chat history:', error);
    }
  },

  saveMessagesToStorage: () => {
    try {
      const { messages } = get();
      // Храним только последние 50 сообщений
      const messagesToStore = messages.slice(-50);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(messagesToStore));
    } catch (error) {
      console.error('Error saving chat history:', error);
    }
  }
}));
